import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[textDetailDirective]',
})
export class TextDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}